var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var dsplL = {
    fontFamily: 'var(--plasma-typo-dspl-l-font-family)',
    fontSize: 'var(--plasma-typo-dspl-l-font-size)',
    fontStyle: 'var(--plasma-typo-dspl-l-font-style)',
    fontWeight: 'var(--plasma-typo-dspl-l-font-weight)',
    letterSpacing: 'var(--plasma-typo-dspl-l-letter-spacing)',
    lineHeight: 'var(--plasma-typo-dspl-l-line-height)',
};
export var dsplLBold = __assign(__assign({}, dsplL), { fontWeight: 'var(--plasma-typo-dspl-l-bold-font-weight)' });
export var dsplM = {
    fontFamily: 'var(--plasma-typo-dspl-m-font-family)',
    fontSize: 'var(--plasma-typo-dspl-m-font-size)',
    fontStyle: 'var(--plasma-typo-dspl-m-font-style)',
    fontWeight: 'var(--plasma-typo-dspl-m-font-weight)',
    letterSpacing: 'var(--plasma-typo-dspl-m-letter-spacing)',
    lineHeight: 'var(--plasma-typo-dspl-m-line-height)',
};
export var dsplMBold = __assign(__assign({}, dsplM), { fontWeight: 'var(--plasma-typo-dspl-m-bold-font-weight)' });
export var dsplS = {
    fontFamily: 'var(--plasma-typo-dspl-s-font-family)',
    fontSize: 'var(--plasma-typo-dspl-s-font-size)',
    fontStyle: 'var(--plasma-typo-dspl-s-font-style)',
    fontWeight: 'var(--plasma-typo-dspl-s-font-weight)',
    letterSpacing: 'var(--plasma-typo-dspl-s-letter-spacing)',
    lineHeight: 'var(--plasma-typo-dspl-s-line-height)',
};
export var dsplSBold = __assign(__assign({}, dsplS), { fontWeight: 'var(--plasma-typo-dspl-s-bold-font-weight)' });
export var h1 = {
    fontFamily: 'var(--plasma-typo-h1-font-family)',
    fontSize: 'var(--plasma-typo-h1-font-size)',
    fontStyle: 'var(--plasma-typo-h1-font-style)',
    fontWeight: 'var(--plasma-typo-h1-font-weight)',
    letterSpacing: 'var(--plasma-typo-h1-letter-spacing)',
    lineHeight: 'var(--plasma-typo-h1-line-height)',
};
export var h1Bold = __assign(__assign({}, h1), { fontWeight: 'var(--plasma-typo-h1-bold-font-weight)' });
export var h2 = {
    fontFamily: 'var(--plasma-typo-h2-font-family)',
    fontSize: 'var(--plasma-typo-h2-font-size)',
    fontStyle: 'var(--plasma-typo-h2-font-style)',
    fontWeight: 'var(--plasma-typo-h2-font-weight)',
    letterSpacing: 'var(--plasma-typo-h2-letter-spacing)',
    lineHeight: 'var(--plasma-typo-h2-line-height)',
};
export var h2Bold = __assign(__assign({}, h2), { fontWeight: 'var(--plasma-typo-h2-bold-font-weight)' });
export var h3 = {
    fontFamily: 'var(--plasma-typo-h3-font-family)',
    fontSize: 'var(--plasma-typo-h3-font-size)',
    fontStyle: 'var(--plasma-typo-h3-font-style)',
    fontWeight: 'var(--plasma-typo-h3-font-weight)',
    letterSpacing: 'var(--plasma-typo-h3-letter-spacing)',
    lineHeight: 'var(--plasma-typo-h3-line-height)',
};
export var h3Bold = __assign(__assign({}, h3), { fontWeight: 'var(--plasma-typo-h3-bold-font-weight)' });
export var h4 = {
    fontFamily: 'var(--plasma-typo-h4-font-family)',
    fontSize: 'var(--plasma-typo-h4-font-size)',
    fontStyle: 'var(--plasma-typo-h4-font-style)',
    fontWeight: 'var(--plasma-typo-h4-font-weight)',
    letterSpacing: 'var(--plasma-typo-h4-letter-spacing)',
    lineHeight: 'var(--plasma-typo-h4-line-height)',
};
export var h4Bold = __assign(__assign({}, h4), { fontWeight: 'var(--plasma-typo-h4-bold-font-weight)' });
export var h5 = {
    fontFamily: 'var(--plasma-typo-h5-font-family)',
    fontSize: 'var(--plasma-typo-h5-font-size)',
    fontStyle: 'var(--plasma-typo-h5-font-style)',
    fontWeight: 'var(--plasma-typo-h5-font-weight)',
    letterSpacing: 'var(--plasma-typo-h5-letter-spacing)',
    lineHeight: 'var(--plasma-typo-h5-line-height)',
};
export var h5Bold = __assign(__assign({}, h5), { fontWeight: 'var(--plasma-typo-h5-bold-font-weight)' });
export var bodyL = {
    fontFamily: 'var(--plasma-typo-body-l-font-family)',
    fontSize: 'var(--plasma-typo-body-l-font-size)',
    fontStyle: 'var(--plasma-typo-body-l-font-style)',
    fontWeight: 'var(--plasma-typo-body-l-font-weight)',
    letterSpacing: 'var(--plasma-typo-body-l-letter-spacing)',
    lineHeight: 'var(--plasma-typo-body-l-line-height)',
};
export var bodyLBold = __assign(__assign({}, bodyL), { fontWeight: 'var(--plasma-typo-body-l-bold-font-weight)' });
export var bodyM = {
    fontFamily: 'var(--plasma-typo-body-m-font-family)',
    fontSize: 'var(--plasma-typo-body-m-font-size)',
    fontStyle: 'var(--plasma-typo-body-m-font-style)',
    fontWeight: 'var(--plasma-typo-body-m-font-weight)',
    letterSpacing: 'var(--plasma-typo-body-m-letter-spacing)',
    lineHeight: 'var(--plasma-typo-body-m-line-height)',
};
export var bodyMBold = __assign(__assign({}, bodyM), { fontWeight: 'var(--plasma-typo-body-m-bold-font-weight)' });
export var bodyS = {
    fontFamily: 'var(--plasma-typo-body-s-font-family)',
    fontSize: 'var(--plasma-typo-body-s-font-size)',
    fontStyle: 'var(--plasma-typo-body-s-font-style)',
    fontWeight: 'var(--plasma-typo-body-s-font-weight)',
    letterSpacing: 'var(--plasma-typo-body-s-letter-spacing)',
    lineHeight: 'var(--plasma-typo-body-s-line-height)',
};
export var bodySBold = __assign(__assign({}, bodyS), { fontWeight: 'var(--plasma-typo-body-s-bold-font-weight)' });
export var bodyXS = {
    fontFamily: 'var(--plasma-typo-body-xs-font-family)',
    fontSize: 'var(--plasma-typo-body-xs-font-size)',
    fontStyle: 'var(--plasma-typo-body-xs-font-style)',
    fontWeight: 'var(--plasma-typo-body-xs-font-weight)',
    letterSpacing: 'var(--plasma-typo-body-xs-letter-spacing)',
    lineHeight: 'var(--plasma-typo-body-xs-line-height)',
};
export var bodyXSBold = __assign(__assign({}, bodyXS), { fontWeight: 'var(--plasma-typo-body-xs-bold-font-weight)' });
export var bodyXXS = {
    fontFamily: 'var(--plasma-typo-body-xxs-font-family)',
    fontSize: 'var(--plasma-typo-body-xxs-font-size)',
    fontStyle: 'var(--plasma-typo-body-xxs-font-style)',
    fontWeight: 'var(--plasma-typo-body-xxs-font-weight)',
    letterSpacing: 'var(--plasma-typo-body-xxs-letter-spacing)',
    lineHeight: 'var(--plasma-typo-body-xxs-line-height)',
};
export var bodyXXSBold = __assign(__assign({}, bodyXXS), { fontWeight: 'var(--plasma-typo-body-xxs-bold-font-weight)' });
export var textL = {
    fontFamily: 'var(--plasma-typo-text-l-font-family)',
    fontSize: 'var(--plasma-typo-text-l-font-size)',
    fontStyle: 'var(--plasma-typo-text-l-font-style)',
    fontWeight: 'var(--plasma-typo-text-l-font-weight)',
    letterSpacing: 'var(--plasma-typo-text-l-letter-spacing)',
    lineHeight: 'var(--plasma-typo-text-l-line-height)',
};
export var textLBold = __assign(__assign({}, textL), { fontWeight: 'var(--plasma-typo-text-l-bold-font-weight)' });
export var textM = {
    fontFamily: 'var(--plasma-typo-text-m-font-family)',
    fontSize: 'var(--plasma-typo-text-m-font-size)',
    fontStyle: 'var(--plasma-typo-text-m-font-style)',
    fontWeight: 'var(--plasma-typo-text-m-font-weight)',
    letterSpacing: 'var(--plasma-typo-text-m-letter-spacing)',
    lineHeight: 'var(--plasma-typo-text-m-line-height)',
};
export var textMBold = __assign(__assign({}, textM), { fontWeight: 'var(--plasma-typo-text-m-bold-font-weight)' });
export var textS = {
    fontFamily: 'var(--plasma-typo-text-s-font-family)',
    fontSize: 'var(--plasma-typo-text-s-font-size)',
    fontStyle: 'var(--plasma-typo-text-s-font-style)',
    fontWeight: 'var(--plasma-typo-text-s-font-weight)',
    letterSpacing: 'var(--plasma-typo-text-s-letter-spacing)',
    lineHeight: 'var(--plasma-typo-text-s-line-height)',
};
export var textSBold = __assign(__assign({}, textS), { fontWeight: 'var(--plasma-typo-text-s-bold-font-weight)' });
export var textXS = {
    fontFamily: 'var(--plasma-typo-text-xs-font-family)',
    fontSize: 'var(--plasma-typo-text-xs-font-size)',
    fontStyle: 'var(--plasma-typo-text-xs-font-style)',
    fontWeight: 'var(--plasma-typo-text-xs-font-weight)',
    letterSpacing: 'var(--plasma-typo-text-xs-letter-spacing)',
    lineHeight: 'var(--plasma-typo-text-xs-line-height)',
};
export var textXSBold = __assign(__assign({}, textXS), { fontWeight: 'var(--plasma-typo-text-xs-bold-font-weight)' });
//# sourceMappingURL=tokens.js.map